import { ItemAggregate } from "./types";
import { num, usd } from "./helpers";

interface Props {
  item: ItemAggregate;
}

export const ItemDetails = ({ item }: Props) => (
  <div className="grid grid-cols-1 md:grid-cols-3 gap-x-8 gap-y-5 p-5 bg-gray-50 border-t border-gray-200">
    <Section title="Sales Breakdown">
      <Row label="Net Sales" value={usd(item.totalNetCents)} bold accent="text-green-700" />
      <Row label="Tax" value={usd(item.totalTaxCents)} />
      <Row label="Discounts" value={usd(item.totalDiscountsCents)} />
      <Row label="Promo Discounts" value={usd(item.totalPromoDiscountsCents)} />
      <Row label="Refunds" value={usd(item.totalRefundsCents)} />
      <Row label="Gross Sales" value={usd(item.totalGrossCents)} />
    </Section>

    <Section title="Payment Mix (Units)">
      <Row label="Cash" value={num(item.cashUnitsSold)} />
      <Row label="Cash Balance" value={num(item.cashBalanceUnitsSold)} />
      <Row label="Credit" value={num(item.creditUnitsSold)} />
      <Row label="RFID" value={num(item.rfidUnitsSold)} />
      <Row label="Tokens" value={num(item.tokenUnitsSold)} />
      <Row label="Total Units" value={num(item.totalUnitsSold)} bold />
    </Section>

    <Section title="Item Details">
      <Row label="Price" value={usd(item.itemPriceCents)} />
      {item.productType && <Row label="Product Type" value={item.productType} />}
      {item.description && <Row label="Description" value={item.description} wrap />}
      {item.upc && <Row label="UPC" value={item.upc} />}
      {item.glAccountName && <Row label="GL Account" value={`${item.glAccountName} (${item.glAccountNumber})`} wrap />}
    </Section>
  </div>
);

const Section = ({ title, children }: { title: string; children: React.ReactNode }) => (
  <div>
    <div className="text-[11px] uppercase tracking-wider text-gray-500 font-semibold pb-2 mb-2 border-b border-gray-300">
      {title}
    </div>
    <dl className="divide-y divide-gray-200">{children}</dl>
  </div>
);

const Row = ({
  label,
  value,
  bold,
  accent,
  wrap,
}: {
  label: string;
  value: string;
  bold?: boolean;
  accent?: string;
  wrap?: boolean;
}) => (
  <div className="flex items-baseline justify-between gap-4 py-1.5">
    <dt className="text-xs uppercase tracking-wide text-gray-500 flex-shrink-0">{label}</dt>
    <dd
      className={`text-sm tabular-nums text-right ${accent ?? "text-gray-900"} ${bold ? "font-bold" : "font-medium"} ${
        wrap ? "break-words" : "whitespace-nowrap"
      }`}
    >
      {value}
    </dd>
  </div>
);
